import axios from "axios";
import { CONFIG } from "../config";


const API_BASE = `${CONFIG.API_URL}/api`;

function getCSRFToken() {
    const name = 'csrftoken';
    const cookies = document.cookie.split(';');
    for (let cookie of cookies) {
      const [key, value] = cookie.trim().split('=');
      if (key === name) {
        return decodeURIComponent(value);
      }
    }
    return '';
  }


export const getWishlist = () =>{
  const token = getCSRFToken();  // Ensure token is retrieved here
  if (!token) {
    console.error("CSRF token not found.");
    return;
  }

  return axios.get(
    `${API_BASE}/wishlist/`, 
  {
    headers: { "X-CSRFToken": token },
    withCredentials: true,
  }
  )
  .catch(err => {
    console.error("Wishlist GET failed:", err.response?.data || err.message);
  });
}

export const removeFromWishlist = (productId) => {
  const token = getCSRFToken();  // Ensure token is retrieved here
  if (!token) {
    console.error("CSRF token not found.");
    return;
  }

  return axios.delete(
    `${API_BASE}/wishlist/${productId}/`, 
    {
      headers: { "X-CSRFToken": token },
      withCredentials: true,
    }
  ).catch(err => {
    console.error("DELETE failed:", err.response?.data || err.message);
  });
};



export const addToWishlist = (productId) => {
  const token = getCSRFToken();  // Ensure token is retrieved here
  const data = {
    product: productId, 
  };
  console.log()
  if (!token) {
    console.error("CSRF token not found.");
    return;
  }

  return axios.post(
    `${API_BASE}/wishlist/`, data, 
    {
      headers: { "X-CSRFToken": token },
      withCredentials: true,
    }
  ).catch(err => {
    console.error("POST failed:", err.response?.data || err.message);
  });
};
    

